var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"pageFooter",class:{
    'pageFooter--autoMargin': _vm.autoMargin && !_vm.noMargin,
    'pageFooter--noMargin': _vm.noMargin
  }},[_c('a',{attrs:{"href":_vm.legalNotice,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Legal Notice")])])
}
var staticRenderFns = []

export { render, staticRenderFns }